module.exports = __webpack_public_path__ + "static/context-b67425ae2869f64c20fe8182ef149244.png";